import { ListItem, Typography } from '@mui/joy';
import { List, ListItemContent } from '@mui/joy';
import { ListProps } from '@mui/joy';
import { isNull } from 'lodash';
import { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Color } from 'theme/enums';
import { Level } from 'theme/enums';

interface IProps<T> extends ListProps {
  items: T[];
  itemRenderer: (item: T) => ReactNode;
  getItemKey?: (item: T) => string | number;
  marker?: string;
  maxItems?: number;
}

const DEFAULT_MAX_ITEMS = 15;

export const ExpandableList = <T,>({
  items,
  itemRenderer,
  getItemKey = (item: T) => String((item as unknown as { id: number }).id),
  maxItems = DEFAULT_MAX_ITEMS,
  marker = 'decimal',
  ...props
}: IProps<T>) => {
  const [showAllItems, setShowAllItems] = useState(false);

  const { t } = useTranslation();

  const lessItems = !isNull(maxItems) ? items.slice(0, showAllItems ? undefined : maxItems) : items;

  return (
    <>
      <List marker={marker} {...props}>
        {lessItems.map((item) => (
          <ListItem key={getItemKey(item)} sx={marker ? {} : { padding: 0 }}>
            <ListItemContent>{itemRenderer(item)}</ListItemContent>
          </ListItem>
        ))}

        {!isNull(maxItems) && items.length > maxItems && (
          <Typography
            color={Color.PRIMARY}
            level={Level.BODY_SM}
            sx={{
              cursor: 'pointer',
              '&:hover': {
                fontWeight: 600,
              },
            }}
            onClick={() => setShowAllItems(!showAllItems)}
          >
            {showAllItems
              ? t('labelShowLess')
              : t('labelMoreCount', {
                  count: items.length - maxItems,
                })}
          </Typography>
        )}
      </List>
    </>
  );
};
